export enum RecaptchaMode {
    Copyright = "Copyright",
    Widget = "Widget"
}
